import { Link } from "wouter";
import { ChevronRight } from "lucide-react";
import { SimpleHeader, SimpleFooter, AnimatedBlock } from "@/components/simple-page-chrome";
import { FAQ_PAGE_ITEMS } from "@/content/faq";

export default function FaqPage() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_PAGE_ITEMS.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <SimpleHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <AnimatedBlock>
          <p className="text-sm font-medium text-primary tracking-wider uppercase mb-3">Preguntas frecuentes</p>
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Preguntas frecuentes sobre la NOM-035
          </h1>
          <p className="text-muted-foreground mb-12 max-w-2xl">
            Respuestas directas a las dudas más comunes de las empresas mexicanas sobre la NOM-035-STPS y cómo MAPA35 ayuda a cumplirla.
          </p>
        </AnimatedBlock>

        <div className="divide-y divide-border">
          {FAQ_PAGE_ITEMS.map((item, i) => (
            <AnimatedBlock key={item.slug} delay={Math.min(i * 0.03, 0.3)}>
              <details id={item.slug} className="group py-5">
                <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-serif font-semibold text-foreground">
                  {item.question}
                  <ChevronRight className="w-4 h-4 flex-shrink-0 text-primary transition-transform duration-200 group-open:rotate-90" />
                </summary>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{item.answer}</p>
              </details>
            </AnimatedBlock>
          ))}
        </div>

        <AnimatedBlock delay={0.1}>
          <div className="mt-16 pt-10 border-t">
            <p className="text-sm font-medium text-foreground mb-4">Sigue explorando</p>
            <div className="flex flex-wrap gap-4">
              <Link href="/glosario" className="text-sm text-primary hover:underline" data-testid="link-faq-to-glosario">
                Ver el glosario de términos NOM-035 →
              </Link>
              <Link href="/#contacto" className="text-sm text-primary hover:underline" data-testid="link-faq-to-contacto">
                Solicitar diagnóstico gratuito →
              </Link>
            </div>
          </div>
        </AnimatedBlock>
      </main>
      <SimpleFooter />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </div>
  );
}
